module.exports = __webpack_public_path__ + "img/entities.58cb50a9.svg";